// The one non-trivial piece of labelling logic behind the debug preprocessor-variant
// picker, kept out of the component file so that file exports only its component (plus
// two constant strings) — `react-refresh/only-export-components` is an eslint ERROR here
// and the baseline is zero, and it permits constant exports but not function exports.
//
// Worth its own module regardless: "what is the default" is the part of the picker with a
// real rule in it (a flag value, else the listing's own `is_default`, else a placeholder),
// and it is the part worth testing without rendering anything.

/**
 * Label the default entry with what the default actually IS, so the dropdown never says
 * "Default" without saying default-to-what. `deploymentDefault` is this environment's
 * `chatboard-preprocess-variant` flag value; "" means the flag has no opinion and the
 * contract server's own registry default applies — which the listing separately marks with
 * `is_default`, so we name that variant rather than the empty string.
 *
 * @param {string} deploymentDefault The flag value ("" for the registry default).
 * @param {Array<{id: string, label: string, is_default?: boolean}>} variants The listing.
 * @returns {string} e.g. `Default (Quantile band (live))`.
 */
export function defaultOptionLabel(deploymentDefault, variants = []) {
  const named = deploymentDefault
    ? variants.find((v) => v.id === deploymentDefault)
    : variants.find((v) => v.is_default === true);
  const shown = named ? named.label : deploymentDefault || "server default";
  return `Default (${shown})`;
}
